import { render, staticRenderFns } from "./detailsCahierTexte.vue?vue&type=template&id=33611bab&"
import script from "./detailsCahierTexte.vue?vue&type=script&lang=js&"
export * from "./detailsCahierTexte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports